import { useLocation } from 'react-router';
import { getFullEpisodeWizardQueryParams } from 'utils/routes';

export default function useEpisodeWizardQueryParams() {
  const { search } = useLocation();
  return getFullEpisodeWizardQueryParams(search);
}
